import axios from 'axios';
export class Config {
    constructor(assetPathResolverService) {
        this.assetPathResolverService = assetPathResolverService;
    }
    getConfig(siteContext, site, type) {
        const configPath = Config.getConfigPath(siteContext, site, type);
        return this.getConfigFromPath(configPath);
    }
    static getConfigPath(siteContext, site, type) {
        return `/assets/configs/${siteContext.toLocaleLowerCase() === 'blk' ? 'blk/' : ''}${type}-config.${site.toLocaleLowerCase()}.json`;
    }
    getConfigFromPath(configPath) {
        const config = this.assetPathResolverService.getPath(configPath);
        return axios.get(config);
    }
}
